export default function Results() {
  const stats = [
    { number: '30〜40万円程度', label: 'SFC修行費用(目安)' },
    { number: '8〜12円', label: 'PP単価(目安)' },
    { number: '3年+', label: 'ダイヤモンド継続実績' }
  ];

  return (
    <section className="py-32 px-6 bg-[#FAFAF8]">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B4A] text-center mb-20">
          実績に基づく、再現可能な設計
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow flex flex-col items-center justify-center text-center">
              <div className="text-5xl font-extrabold text-[#0D47A1] mb-3 text-center w-full" style={{ fontFamily: 'DIN, sans-serif' }}>
                {stat.number}
              </div>
              <div className="text-sm text-[#5A5A5A] text-center w-full">{stat.label}</div>
            </div>
          ))}
        </div>

        <p className="text-center text-[13px] text-[#9E9E9E] italic">
          ※ 路線・時期により変動します。個別設計で最適化します。
        </p>
      </div>
    </section>
  );
}
